export { applyBackgroundBlurForLocalPublish } from './lib/apply-background-blur-for-publish'
// Pipeline (+ MediaPipe) is loaded only via dynamic import inside maybeApplyBackgroundBlur.
// Do not re-export createBackgroundBlurPipeline here — that would keep it in the critical graph.
export type {
  BackgroundBlurMode,
  BackgroundBlurPipelineHandle,
  BackgroundBlurPipelineOptions,
} from './lib/create-background-blur-pipeline'
export { isBackgroundBlurSupported } from './lib/is-background-blur-supported'
export {
  detachBackgroundBlurPipelinesForRestoreStream,
  detachBackgroundBlurProcessor,
  forEachBackgroundBlurBinding,
  getBackgroundBlurBinding,
  isBackgroundBlurProcessedStream,
  maybeApplyBackgroundBlur,
  stopAllBackgroundBlurPipelines,
  stopIdleBackgroundBlurPipelines,
  updateBackgroundBlurStrengthOnActive,
} from './lib/maybe-apply-background-blur'
export { reapplyBackgroundBlurOnActiveSessions } from './lib/reapply-background-blur-on-sessions'
export { requestKeyframeAfterReplace } from './lib/request-keyframe-after-replace'
export { requestKeyframesOnActiveLocalWebcams } from './lib/request-keyframes-on-active-local-webcams'
export { upgradePublishedWebcamToBackgroundBlur } from './lib/upgrade-published-webcam-to-blur'
export { watchBackgroundBlurPreference } from './lib/watch-background-blur-preference'
/** Dynamic — module imports @wui/im; do not static-re-export the impl. */
export const loadWatchConferenceJoinForWebcamKeyframes = () => (
  import('./lib/watch-conference-join-for-webcam-keyframes')
    .then((m) => m.watchConferenceJoinForWebcamKeyframes)
)
export { useBackgroundBlurPreference } from './model/use-background-blur-preference'
export { default as BackgroundBlurControls } from './ui/background-blur-controls.vue'
